import { View, Text, Pressable, ScrollView, StyleSheet } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { ADMIN_COLORS, ADMIN_FONT } from '../../config/theme/adminColors';

export const CATALOG_VITRINE_ENABLE_BLOCKED_TITLE =
  'Não é possível ativar a Vitrine de Produtos. Corrija as pendências abaixo na aba Produtos:';

export const CATALOG_VITRINE_ACTIVE_WARNING_TITLE =
  'Importante: os seguintes produtos não estão aparecendo na vitrine. Corrija na aba Produtos:';

const SECTION_PHOTO_TITLE = 'Sem imagem de capa:';
const SECTION_CATEGORY_TITLE = 'Sem categoria:';
const SECTION_PUBLISHED_MODULE_TITLE =
  'Sem módulo publicado (todos os módulos vinculados estão arquivados ou ocultos):';

function ReadinessSection({ title, productNames = [] }) {
  if (!productNames.length) return null;

  return (
    <View style={styles.section}>
      <Text style={styles.sectionTitle}>{title}</Text>
      {productNames.map((name) => (
        <Text key={name} style={styles.listItem}>
          {name}
        </Text>
      ))}
    </View>
  );
}

export function CatalogVitrineReadinessBanner({
  missingPhotoProductNames = [],
  missingCategoryProductNames = [],
  missingPublishedModuleProductNames = [],
  onClose,
  title = CATALOG_VITRINE_ENABLE_BLOCKED_TITLE,
}) {
  const hasIssues =
    missingPhotoProductNames.length > 0 ||
    missingCategoryProductNames.length > 0 ||
    missingPublishedModuleProductNames.length > 0;

  if (!hasIssues) return null;

  return (
    <View style={styles.wrap}>
      <View style={styles.banner}>
        {onClose ? (
          <Pressable onPress={onClose} hitSlop={8} style={styles.close}>
            <Ionicons name="close" size={16} color={ADMIN_COLORS.danger} />
          </Pressable>
        ) : null}

        <View style={styles.headerRow}>
          <Ionicons name="alert-circle-outline" size={20} color={ADMIN_COLORS.danger} />
          <Text style={styles.title}>{title}</Text>
        </View>

        <ScrollView
          style={styles.listScroll}
          contentContainerStyle={styles.listContent}
          nestedScrollEnabled
          showsVerticalScrollIndicator
        >
          <ReadinessSection
            title={SECTION_PHOTO_TITLE}
            productNames={missingPhotoProductNames}
          />
          <ReadinessSection
            title={SECTION_CATEGORY_TITLE}
            productNames={missingCategoryProductNames}
          />
          <ReadinessSection
            title={SECTION_PUBLISHED_MODULE_TITLE}
            productNames={missingPublishedModuleProductNames}
          />
        </ScrollView>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  wrap: {
    width: '100%',
    alignItems: 'center',
    marginTop: 4,
    marginBottom: 8,
  },
  banner: {
    width: '100%',
    maxWidth: 520,
    alignSelf: 'center',
    backgroundColor: ADMIN_COLORS.dangerSoft,
    borderWidth: 1,
    borderColor: ADMIN_COLORS.dangerBorder,
    borderRadius: 12,
    paddingHorizontal: 16,
    paddingTop: 14,
    paddingBottom: 12,
    position: 'relative',
  },
  close: {
    position: 'absolute',
    top: 10,
    right: 10,
    zIndex: 1,
    cursor: 'pointer',
  },
  headerRow: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    gap: 8,
    marginBottom: 10,
    paddingRight: 20,
  },
  title: {
    flex: 1,
    fontFamily: ADMIN_FONT,
    fontSize: 13,
    lineHeight: 19,
    fontWeight: '600',
    color: ADMIN_COLORS.danger,
    textAlign: 'left',
  },
  listScroll: {
    maxHeight: 200,
    width: '100%',
    paddingLeft: 28,
  },
  listContent: {
    alignItems: 'flex-start',
    paddingBottom: 4,
    gap: 10,
  },
  section: {
    width: '100%',
    gap: 2,
  },
  sectionTitle: {
    fontFamily: ADMIN_FONT,
    fontSize: 13,
    lineHeight: 20,
    fontWeight: '700',
    color: ADMIN_COLORS.danger,
    textAlign: 'left',
  },
  listItem: {
    fontFamily: ADMIN_FONT,
    fontSize: 13,
    lineHeight: 22,
    color: ADMIN_COLORS.danger,
    textAlign: 'left',
  },
});

export default CatalogVitrineReadinessBanner;
